import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface SecurityIconProps {
  size?: number;
  color?: string;
}

const SecurityIcon: React.FC<SecurityIconProps> = ({ size = 16, color = '#005CBC' }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" preserveAspectRatio="xMidYMid meet">
      <Path d="M8 0.666672L2 3.33334V7.33334C2 11.0333 4.56 14.4933 8 15.3333C11.44 14.4933 14 11.0333 14 7.33334V3.33334L8 0.666672ZM8 7.99334H12.6667C12.3133 10.74 10.48 13.1867 8 13.9533V8H3.33333V4.20001L8 2.12667V7.99334Z" fill={color} />
    </Svg>
  );
};

export default SecurityIcon;
